/* Oak & Hour, placeholder poster art.
   Every product renders a generated SVG poster: a warm light-wash
   gradient in the department tint, a fall of window light, a floor
   line, and a hand-drawn furniture silhouette. Replaced later by
   real photography and film per VIDEO-BRIEF.md. */

window.OH = window.OH || {};

(function () {
  const INK = "#241A11";
  const CREAM = "#FCF8EF";

  /* Each silhouette is drawn on a floor baseline at y=0, centered on
     x=0, negative y is up. Shapes are separated by small gaps so the
     forms read against the wash. Cream shapes suggest light or detail. */
  const SIL = {
    sofa: `
      <rect x="-110" y="-150" width="220" height="86" rx="14"/>
      <rect x="-160" y="-128" width="44" height="112" rx="18"/>
      <rect x="116" y="-128" width="44" height="112" rx="18"/>
      <rect x="-108" y="-60" width="104" height="44" rx="10"/>
      <rect x="4" y="-60" width="104" height="44" rx="10"/>
      <rect x="-142" y="-16" width="14" height="16"/>
      <rect x="128" y="-16" width="14" height="16"/>`,
    sectional: `
      <rect x="-150" y="-150" width="240" height="86" rx="14"/>
      <rect x="-196" y="-128" width="40" height="112" rx="16"/>
      <rect x="-146" y="-60" width="90" height="44" rx="10"/>
      <rect x="-48" y="-60" width="90" height="44" rx="10"/>
      <rect x="50" y="-60" width="146" height="44" rx="10"/>
      <rect x="98" y="-128" width="98" height="60" rx="12"/>
      <rect x="-180" y="-16" width="14" height="16"/>
      <rect x="166" y="-16" width="14" height="16"/>`,
    armchair: `
      <rect x="-52" y="-150" width="104" height="86" rx="14"/>
      <rect x="-98" y="-124" width="40" height="110" rx="16"/>
      <rect x="58" y="-124" width="40" height="110" rx="16"/>
      <rect x="-50" y="-58" width="100" height="44" rx="10"/>
      <rect x="-82" y="-14" width="12" height="14"/>
      <rect x="70" y="-14" width="12" height="14"/>`,
    coffeeTable: `
      <rect x="-140" y="-64" width="280" height="16" rx="8"/>
      <rect x="-132" y="-48" width="14" height="48"/>
      <rect x="118" y="-48" width="14" height="48"/>
      <rect x="-120" y="-24" width="240" height="10" rx="5"/>`,
    sideTable: `
      <rect x="-70" y="-110" width="140" height="14" rx="7"/>
      <rect x="-64" y="-96" width="12" height="96"/>
      <rect x="52" y="-96" width="12" height="96"/>
      <rect x="-56" y="-42" width="112" height="10" rx="5"/>`,
    console: `
      <rect x="-150" y="-90" width="94" height="72" rx="8"/>
      <rect x="-48" y="-90" width="96" height="72" rx="8"/>
      <rect x="56" y="-90" width="94" height="72" rx="8"/>
      <rect x="-138" y="-14" width="12" height="14"/>
      <rect x="126" y="-14" width="12" height="14"/>`,
    bookshelf: `
      <rect x="-110" y="-280" width="12" height="280"/>
      <rect x="98" y="-280" width="12" height="280"/>
      <rect x="-98" y="-274" width="196" height="10"/>
      <rect x="-98" y="-208" width="196" height="10"/>
      <rect x="-98" y="-142" width="196" height="10"/>
      <rect x="-98" y="-76" width="196" height="10"/>
      <rect x="-98" y="-10" width="196" height="10"/>
      <rect x="-80" y="-256" width="12" height="48"/>
      <rect x="-62" y="-248" width="12" height="40"/>
      <rect x="-44" y="-252" width="10" height="44"/>
      <rect x="30" y="-190" width="12" height="48"/>
      <rect x="48" y="-182" width="10" height="40"/>
      <rect x="-70" y="-124" width="12" height="48"/>
      <rect x="-52" y="-118" width="10" height="42"/>
      <rect x="60" y="-58" width="12" height="48"/>`,
    ottoman: `
      <rect x="-90" y="-70" width="180" height="54" rx="26"/>
      <rect x="-72" y="-14" width="12" height="14"/>
      <rect x="60" y="-14" width="12" height="14"/>`,
    bed: `
      <rect x="-160" y="-210" width="320" height="84" rx="18"/>
      <rect x="-140" y="-118" width="124" height="30" rx="14"/>
      <rect x="16" y="-118" width="124" height="30" rx="14"/>
      <rect x="-170" y="-80" width="340" height="64" rx="12"/>
      <rect x="-158" y="-14" width="16" height="14"/>
      <rect x="142" y="-14" width="16" height="14"/>`,
    nightstand: `
      <rect x="-70" y="-124" width="140" height="50" rx="10"/>
      <rect x="-70" y="-66" width="140" height="46" rx="10"/>
      <rect x="-58" y="-18" width="12" height="18"/>
      <rect x="46" y="-18" width="12" height="18"/>`,
    dresser: `
      <rect x="-130" y="-164" width="260" height="42" rx="10"/>
      <rect x="-130" y="-114" width="260" height="42" rx="10"/>
      <rect x="-130" y="-64" width="260" height="42" rx="10"/>
      <rect x="-116" y="-20" width="14" height="20"/>
      <rect x="102" y="-20" width="14" height="20"/>`,
    bedding: `
      <rect x="-120" y="-64" width="240" height="54" rx="18"/>
      <rect x="-110" y="-104" width="220" height="34" rx="15"/>
      <rect x="-94" y="-136" width="188" height="26" rx="12"/>
      <rect x="-60" y="-166" width="120" height="24" rx="12"/>`,
    bench: `
      <rect x="-130" y="-76" width="260" height="26" rx="12"/>
      <rect x="-118" y="-48" width="14" height="48"/>
      <rect x="104" y="-48" width="14" height="48"/>`,
    wardrobe: `
      <rect x="-120" y="-300" width="116" height="284" rx="8"/>
      <rect x="4" y="-300" width="116" height="284" rx="8"/>
      <rect x="-14" y="-170" width="6" height="34" fill="${CREAM}" opacity="0.55"/>
      <rect x="8" y="-170" width="6" height="34" fill="${CREAM}" opacity="0.55"/>`,
    diningTable: `
      <rect x="-160" y="-122" width="320" height="16" rx="8"/>
      <rect x="-146" y="-106" width="16" height="106"/>
      <rect x="130" y="-106" width="16" height="106"/>
      <rect x="-146" y="-30" width="292" height="10" rx="5"/>`,
    diningChair: `
      <rect x="-40" y="-192" width="10" height="102"/>
      <rect x="30" y="-192" width="10" height="102"/>
      <rect x="-30" y="-184" width="60" height="10"/>
      <rect x="-30" y="-156" width="60" height="10"/>
      <rect x="-48" y="-90" width="96" height="18" rx="8"/>
      <rect x="-44" y="-72" width="11" height="72"/>
      <rect x="33" y="-72" width="11" height="72"/>`,
    sideboard: `
      <rect x="-150" y="-122" width="94" height="102" rx="8"/>
      <rect x="-48" y="-122" width="96" height="102" rx="8"/>
      <rect x="56" y="-122" width="94" height="102" rx="8"/>
      <rect x="-138" y="-16" width="12" height="16"/>
      <rect x="126" y="-16" width="12" height="16"/>`,
    barCabinet: `
      <rect x="-100" y="-224" width="96" height="206" rx="8"/>
      <rect x="4" y="-224" width="96" height="206" rx="8"/>
      <rect x="-88" y="-14" width="12" height="14"/>
      <rect x="76" y="-14" width="12" height="14"/>
      <rect x="-16" y="-252" width="14" height="26"/>
      <rect x="-11" y="-266" width="5" height="14"/>
      <rect x="12" y="-248" width="12" height="22"/>`,
    stool: `
      <rect x="-55" y="-162" width="110" height="18" rx="9"/>
      <path d="M -46 -144 L -60 0 L -46 0 L -36 -144 Z"/>
      <path d="M 46 -144 L 60 0 L 46 0 L 36 -144 Z"/>
      <rect x="-42" y="-60" width="84" height="9" rx="4"/>`,
    desk: `
      <rect x="-160" y="-122" width="320" height="16" rx="8"/>
      <rect x="-150" y="-106" width="16" height="106"/>
      <rect x="62" y="-106" width="92" height="106" rx="6"/>
      <rect x="70" y="-96" width="76" height="6" fill="${CREAM}" opacity="0.4"/>
      <rect x="70" y="-62" width="76" height="6" fill="${CREAM}" opacity="0.4"/>`,
    officeChair: `
      <rect x="-48" y="-214" width="96" height="96" rx="16"/>
      <rect x="-55" y="-110" width="110" height="22" rx="10"/>
      <rect x="-6" y="-88" width="12" height="58"/>
      <rect x="-58" y="-30" width="116" height="10" rx="5"/>
      <circle cx="-46" cy="-11" r="9"/>
      <circle cx="46" cy="-11" r="9"/>`,
    shelving: `
      <rect x="-104" y="-280" width="11" height="280"/>
      <rect x="93" y="-280" width="11" height="280"/>
      <rect x="-93" y="-262" width="186" height="9"/>
      <rect x="-93" y="-186" width="186" height="9"/>
      <rect x="-93" y="-110" width="186" height="9"/>
      <rect x="-93" y="-34" width="186" height="9"/>
      <rect x="-72" y="-246" width="11" height="46"/>
      <rect x="-54" y="-238" width="10" height="38"/>
      <rect x="40" y="-170" width="11" height="46"/>
      <rect x="58" y="-162" width="10" height="38"/>
      <rect x="-64" y="-94" width="11" height="46"/>`,
    pendant: `
      <rect x="-2" y="-420" width="4" height="130"/>
      <path d="M -72 -206 L 72 -206 L 40 -290 L -40 -290 Z"/>
      <circle cx="0" cy="-186" r="12" fill="${CREAM}" opacity="0.9"/>
      <circle cx="0" cy="-178" r="34" fill="${CREAM}" opacity="0.18"/>`,
    floorLamp: `
      <rect x="-5" y="-252" width="10" height="252"/>
      <rect x="-52" y="-12" width="104" height="12" rx="6"/>
      <path d="M -56 -252 L 56 -252 L 38 -318 L -38 -318 Z"/>
      <circle cx="0" cy="-236" r="11" fill="${CREAM}" opacity="0.9"/>
      <circle cx="0" cy="-228" r="30" fill="${CREAM}" opacity="0.16"/>`,
    tableLamp: `
      <path d="M -62 -140 L 62 -140 L 42 -204 L -42 -204 Z"/>
      <rect x="-24" y="-134" width="48" height="106" rx="20"/>
      <rect x="-46" y="-16" width="92" height="16" rx="8"/>
      <circle cx="0" cy="-122" r="10" fill="${CREAM}" opacity="0.85"/>`,
    sconce: `
      <rect x="-64" y="-236" width="18" height="70" rx="8"/>
      <rect x="-46" y="-208" width="44" height="9"/>
      <rect x="-4" y="-224" width="60" height="44" rx="18"/>
      <circle cx="26" cy="-162" r="12" fill="${CREAM}" opacity="0.85"/>
      <circle cx="26" cy="-154" r="30" fill="${CREAM}" opacity="0.16"/>`,
    rug: `
      <rect x="-172" y="-52" width="344" height="48" rx="9"/>
      <rect x="-150" y="-42" width="300" height="28" rx="6" fill="none" stroke="${CREAM}" stroke-width="4" opacity="0.55"/>
      <rect x="-176" y="-40" width="6" height="24" fill="${CREAM}" opacity="0.4"/>
      <rect x="170" y="-40" width="6" height="24" fill="${CREAM}" opacity="0.4"/>`,
    throw: `
      <rect x="-92" y="-124" width="184" height="118" rx="30"/>
      <path d="M -40 -124 C -48 -84 -34 -46 -44 -6" fill="none" stroke="${CREAM}" stroke-width="4" opacity="0.5"/>
      <path d="M 28 -124 C 20 -86 36 -44 26 -6" fill="none" stroke="${CREAM}" stroke-width="4" opacity="0.5"/>
      <rect x="-92" y="-30" width="184" height="7" fill="${CREAM}" opacity="0.4"/>`,
    cushion: `
      <g transform="rotate(-4)">
        <rect x="-84" y="-158" width="168" height="152" rx="30"/>
        <rect x="-68" y="-142" width="136" height="120" rx="22" fill="none" stroke="${CREAM}" stroke-width="4" opacity="0.5"/>
      </g>`,
    mirror: `
      <g transform="rotate(2)">
        <rect x="-82" y="-302" width="164" height="296" rx="42" fill="none" stroke="${INK}" stroke-width="15"/>
        <rect x="-64" y="-284" width="128" height="260" rx="34" fill="${CREAM}" opacity="0.28"/>
        <path d="M -34 -270 L -6 -242 M -18 -276 L 22 -236" stroke="${CREAM}" stroke-width="7" opacity="0.6" fill="none"/>
      </g>`,
    vase: `
      <rect x="-40" y="-140" width="80" height="130" rx="32"/>
      <rect x="-16" y="-180" width="32" height="44" rx="8"/>
      <path d="M 0 -180 C 8 -216 -12 -232 2 -266" fill="none" stroke="${INK}" stroke-width="5"/>
      <circle cx="6" cy="-270" r="8"/>
      <circle cx="-10" cy="-244" r="6"/>
      <circle cx="12" cy="-222" r="5"/>`,
    candle: `
      <rect x="-38" y="-92" width="76" height="92" rx="10"/>
      <rect x="-30" y="-80" width="60" height="5" fill="${CREAM}" opacity="0.5"/>
      <rect x="-2" y="-102" width="4" height="12"/>
      <circle cx="0" cy="-112" r="8" fill="${CREAM}" opacity="0.9"/>
      <circle cx="0" cy="-110" r="20" fill="${CREAM}" opacity="0.2"/>`,
    wallArt: `
      <rect x="-112" y="-268" width="224" height="208" rx="6" fill="none" stroke="${INK}" stroke-width="13"/>
      <circle cx="34" cy="-196" r="27" fill="${CREAM}" opacity="0.55"/>
      <path d="M -100 -120 C -60 -150 -20 -110 20 -132 C 60 -152 80 -128 100 -138 L 100 -72 L -100 -72 Z" opacity="0.85"/>`,
    object: `
      <path d="M -80 -66 C -78 -14 78 -14 80 -66 L 64 -66 C 62 -28 -62 -28 -64 -66 Z"/>
      <path d="M -80 -66 C -78 -14 78 -14 80 -66 Z" opacity="0.9"/>
      <rect x="-26" y="-10" width="52" height="10" rx="4"/>`
  };

  /* Fallback for any unknown silhouette key */
  const FALLBACK = SIL.object;

  let uid = 0;
  const hash = s => String(s || "").split("").reduce((a, c) => (a * 31 + c.charCodeAt(0)) % 9973, 7);

  /* Build a poster SVG string.
     item: { tint, silhouette, id? } or { tint, scene: [{sil,dx,dy,s}] }
     opts: { wide: bool } for 16:9 bands instead of 4:5 cards.
     Every poster is a small room at a certain hour: a graded wash of
     light, a window beam with pane shadows, dust in the air, a floor
     with a faint reflection, and the piece itself settled on it. The
     light varies per product so the catalog never repeats a frame. */
  OH.poster = function (item, opts) {
    opts = opts || {};
    /* the photography unlock: any item with a photo path renders it,
       so products migrate to real imagery one at a time */
    if (item.photo) {
      return `<img src="${item.photo}" alt="" loading="lazy" decoding="async" style="width:100%; height:100%; object-fit:cover; display:block">`;
    }
    const tints = OH.CONFIG.tints[item.tint] || OH.CONFIG.tints.tungsten;
    const light = tints[0], deep = tints[1];
    /* product posters are square, 1:1, matching the real supplier imagery to come */
    const W = opts.wide ? 960 : 560;
    const H = opts.wide ? 540 : 560;
    const floorY = opts.wide ? 462 : 470;
    const cx = W / 2;
    const id = "pg" + (++uid);
    const h = hash(item.id || item.silhouette || "x");
    const beamRight = h % 2 === 0;                 /* which window the sun uses */
    const glowX = 0.2 + (h % 3) * 0.12;            /* where the warm bloom sits */
    const gradTilt = 0.7 + (h % 4) * 0.1;          /* the angle of the fade */
    const scale = opts.wide ? 0.92 : 1;

    /* the piece, or a whole composed room */
    let subject;
    if (item.scene) {
      subject = item.scene.map(el =>
        `<g transform="translate(${el.dx || 0},${el.dy || 0}) scale(${el.s || 1})">${SIL[el.sil] || FALLBACK}</g>`).join("");
    } else {
      subject = SIL[item.silhouette] || FALLBACK;
    }

    /* window beam: a broad fall of light with two pane shadows in it */
    const beam = beamRight
      ? `<polygon points="${W * 0.6},0 ${W},0 ${W},${H * 0.52} ${W * 0.72},${H} ${W * 0.54},${H}" fill="${CREAM}" opacity="0.1"/>
         <polygon points="${W * 0.71},0 ${W * 0.745},0 ${W * 0.64},${H} ${W * 0.615},${H}" fill="${INK}" opacity="0.05"/>
         <polygon points="${W * 0.84},0 ${W * 0.865},0 ${W * 0.77},${H} ${W * 0.745},${H}" fill="${INK}" opacity="0.05"/>`
      : `<polygon points="0,0 ${W * 0.4},0 ${W * 0.46},${H * 0.52} ${W * 0.46},${H} ${W * 0.28},${H}" fill="${CREAM}" opacity="0.1"/>
         <polygon points="${W * 0.13},0 ${W * 0.155},0 ${W * 0.26},${H} ${W * 0.235},${H}" fill="${INK}" opacity="0.05"/>
         <polygon points="${W * 0.26},0 ${W * 0.285},0 ${W * 0.38},${H} ${W * 0.355},${H}" fill="${INK}" opacity="0.05"/>`;

    /* dust motes and the floor reflection are invisible at card size,
       so lite posters (grids, thumbs) skip their render cost */
    const bx = beamRight ? W * 0.72 : W * 0.3;
    const motes = opts.lite ? "" : [0.14, 0.24, 0.33, 0.45, 0.55, 0.66].map((f, i) =>
      `<circle cx="${bx + ((h + i * 37) % 90) - 45}" cy="${H * f}" r="${1.2 + (i % 3) * 0.7}" fill="${CREAM}" opacity="${0.18 + (i % 3) * 0.09}"/>`).join("");
    const reflection = opts.lite ? "" :
      `<g transform="translate(${cx},${floorY + 4}) scale(${scale}) scale(1,-0.32)" fill="${INK}" mask="url(#${id}rm)" opacity="0.35">${subject}</g>`;

    return `<svg viewBox="0 0 ${W} ${H}" xmlns="http://www.w3.org/2000/svg" role="img" aria-hidden="true" preserveAspectRatio="xMidYMid slice">
  <defs>
    <linearGradient id="${id}" x1="0" y1="0" x2="${gradTilt}" y2="1">
      <stop offset="0" stop-color="${light}"/>
      <stop offset="0.55" stop-color="${mix(light, deep)}"/>
      <stop offset="1" stop-color="${deep}"/>
    </linearGradient>
    <radialGradient id="${id}g" cx="${glowX}" cy="0.18" r="0.6">
      <stop offset="0" stop-color="${CREAM}" stop-opacity="0.32"/>
      <stop offset="1" stop-color="${CREAM}" stop-opacity="0"/>
    </radialGradient>
    <radialGradient id="${id}v" cx="0.5" cy="0.46" r="0.85">
      <stop offset="0.62" stop-color="${INK}" stop-opacity="0"/>
      <stop offset="1" stop-color="${INK}" stop-opacity="0.22"/>
    </radialGradient>
    <linearGradient id="${id}f" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="${INK}" stop-opacity="0.1"/>
      <stop offset="1" stop-color="${INK}" stop-opacity="0.24"/>
    </linearGradient>
    <linearGradient id="${id}rg" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#fff" stop-opacity="0.35"/>
      <stop offset="1" stop-color="#fff" stop-opacity="0"/>
    </linearGradient>
    <mask id="${id}rm"><rect x="${-W}" y="0" width="${W * 2}" height="200" fill="url(#${id}rg)"/></mask>
  </defs>
  <rect width="${W}" height="${H}" fill="url(#${id})"/>
  <rect width="${W}" height="${H}" fill="url(#${id}g)"/>
  ${beam}
  ${motes}
  <rect y="${floorY}" width="${W}" height="${H - floorY}" fill="url(#${id}f)"/>
  <rect y="${floorY - 1}" width="${W}" height="1.5" fill="${CREAM}" opacity="0.14"/>
  ${reflection}
  <ellipse cx="${cx}" cy="${floorY + 5}" rx="${W * 0.33}" ry="12" fill="${INK}" opacity="0.18"/>
  <g transform="translate(${cx},${floorY}) scale(${scale})" fill="${INK}" opacity="0.93">${subject}</g>
  <rect width="${W}" height="${H}" fill="url(#${id}v)"/>
</svg>`;
  };

  /* mix two hex colors at 50 percent, for the gradient midpoint */
  function mix(a, b) {
    const p = c => [parseInt(c.slice(1, 3), 16), parseInt(c.slice(3, 5), 16), parseInt(c.slice(5, 7), 16)];
    const [r1, g1, b1] = p(a), [r2, g2, b2] = p(b);
    const t = n => Math.round(n).toString(16).padStart(2, "0");
    return "#" + t((r1 + r2) / 2) + t((g1 + g2) / 2) + t((b1 + b2) / 2);
  }

  /* Department doorways are composed rooms, not single objects:
     a sofa with its lamp, a bed with its nightstand, a set table. */
  const DEPT_SCENES = {
    living: [
      { sil: "rug", dx: 0, s: 1.12 }, { sil: "wallArt", dx: -162, s: 0.68 },
      { sil: "sofa", dx: -28, s: 0.98 }, { sil: "floorLamp", dx: 158, s: 0.8 }
    ],
    bedroom: [
      { sil: "wallArt", dx: -150, s: 0.6 }, { sil: "bed", dx: -20, s: 0.95 },
      { sil: "nightstand", dx: 168, s: 0.72 }, { sil: "tableLamp", dx: 168, dy: -89, s: 0.42 }
    ],
    dining: [
      { sil: "rug", dx: 0, s: 1.1 }, { sil: "pendant", dx: 0, s: 0.95 },
      { sil: "diningChair", dx: -128, s: 0.88 }, { sil: "diningChair", dx: 128, s: 0.88 },
      { sil: "diningTable", dx: 0, s: 0.96 }
    ],
    study: [
      { sil: "rug", dx: 10, s: 0.9 }, { sil: "desk", dx: 26, s: 0.94 },
      { sil: "tableLamp", dx: 118, dy: -115, s: 0.38 }, { sil: "officeChair", dx: -168, s: 0.78 }
    ],
    lighting: [
      { sil: "pendant", dx: 148, s: 0.9 }, { sil: "floorLamp", dx: -138, s: 0.92 },
      { sil: "sideTable", dx: 40, s: 0.8 }, { sil: "tableLamp", dx: 40, dy: -88, s: 0.42 }
    ],
    "rugs-textiles": [
      { sil: "rug", dx: 0, s: 1.18 }, { sil: "bench", dx: -52, s: 0.9 },
      { sil: "throw", dx: -52, dy: -62, s: 0.48 }, { sil: "cushion", dx: 128, s: 0.55 }
    ],
    decor: [
      { sil: "mirror", dx: -152, s: 0.72 }, { sil: "console", dx: 60, s: 0.85 },
      { sil: "vase", dx: 18, dy: -77, s: 0.42 }, { sil: "candle", dx: 118, dy: -77, s: 0.42 }
    ]
  };
  OH.deptPoster = function (deptKey, opts) {
    const dept = OH.CONFIG.departments.find(d => d.key === deptKey);
    return OH.poster({
      tint: dept ? dept.tint : "tungsten",
      id: "dept-" + deptKey,
      scene: DEPT_SCENES[deptKey] || [{ sil: "object", dx: 0, s: 1 }]
    }, opts);
  };
})();
